import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';

import { SettingsPage } from '@/components/templates/SettingsPage/SettingsPage';
import useFeatureFlag from '@/hooks/useFeatureFlag';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

import { DangerSection } from './sections/DangerSection';
import { InvitationsSection } from './sections/InvitationsSection';
import { NotificationsSection } from './sections/NotificationsSection';
import { PreferencesSection } from './sections/PreferencesSection';
import { ProfileSection } from './sections/ProfileSection';

const Profile = () => {
  const { t } = useTranslation();
  // DON'T REMOVE: Profile is not under Account, so flags must be loaded here
  useFeatureFlag();
  useTitle(t('pages.profile'));

  useSegments(PageName.PERSONAL_PROFILE);

  return (
    <SettingsPage>
      <ProfileSection />
      <InvitationsSection />
      <NotificationsSection />
      <PreferencesSection />
      <DangerSection />
    </SettingsPage>
  );
};

export default Profile;
